/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable ban/ban */
import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ProductGallery extends ThemeComponent {
    @Ref videoPlayers!: HTMLElement[];

    init() {
        this.playVideo();
    }

    private playVideo() {
        this.videoPlayers.forEach((video) => {
            const videoPlayer = video.querySelector('video') as HTMLVideoElement;
            this.$listen(videoPlayer, 'mouseover', () => {
                videoPlayer.play();
            });
            this.$listen(videoPlayer, 'mouseout', () => {
                videoPlayer.pause();
                videoPlayer.currentTime = 0;
            });
        });
    }
}
